import React, { Component } from 'react';
import Firebase from 'firebase';
import { Dropdown, DropdownMenu, DropdownItem, Progress } from 'reactstrap';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';


class LastReg extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chart: {
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: '# of Votes',
                            data: [],
                            fillColor: "rgba(254, 27, 34, 0.3)",
                            pointColor: "rgba(254, 27, 34, 0.3)",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: "rgba(254, 27, 34, 0.3)",
                            pointStrokeColor: "#fff",
                            strokeColor: "rgba(254, 27, 34, 0.3)",
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)'
                            ],
                            borderColor: [
                                'rgba(255,99,132,1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)'
                            ],
                            borderWidth: 1
                        }
                    ]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                }
            }
        };
        this.renderTabla = this.renderTabla.bind(this);
    }


    componentWillReceiveProps(nextProps) {
        var d = new Date();
        var version;
        d.setUTCHours(0, 0, 0, 0);
        const time = +d;
        var charts = this.state.chart;
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId);
        dataRef.on('value', snap => {
            version = Object.keys(snap.val())[Object.keys(snap.val()).length - 1];
        })
        var datosRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextProps.formId + "/" + version + "/raw/data");
        datosRef.orderByChild("global/date/device").startAt(time)
            .on('value', snap => {
                var tabla = [];
                snap.forEach(function (childSnapshot) {
                    var date = new Date(childSnapshot.val().global.date.device);
                    var yyyy = date.getFullYear().toString();
                    var mm = (date.getMonth() + 1).toString();
                    var dd = date.getDate().toString();
                    var hh = date.getHours().toString();
                    var mn = date.getMinutes().toString();
                    tabla.push({
                        "rut": childSnapshot.val().global.user.rut,
                        "nombre": childSnapshot.val().global.user.name,
                        "hora": (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]),
                        "fecha": (dd[1] ? dd : "0" + dd[0]) + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + yyyy,
                        "lugar": { lat: childSnapshot.val().global.gps.lat, lon: childSnapshot.val().global.gps.lon }
                    })
                });
                this.setState({ registros: tabla });
            })
    }

    renderTabla() {
        if (this.state.registros) {
            return (
                <table className="table">
                    <thead>
                        <tr>
                            <th className="hidden-xs">Rut</th>
                            <th>Nombre</th>
                            <th>Hora</th>
                            <th>Fecha</th>
                            <th>Lugar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.registros.reverse().map((r, index) => (
                                <tr key={index}>
                                    <td className="hidden-xs">{r.rut}</td>
                                    <td>{r.nombre}</td>
                                    <td>{r.hora}</td>
                                    <td>{r.fecha}</td>
                                    <td onClick={() => this.props.setGPS(r.lugar.lat, r.lugar.lon)}>
                                        {
                                            r.lugar.lat !== 0 && r.lugar.lon !== 0 ?
                                                <a style={{ cursor: "pointer" }}>Ver</a>
                                                :
                                                "No disponible"
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            )
        }
    }

    render() {
        return (
            <div className="card-block">
                <div className="card">
                    <div className="card-header">
                        <i className="fa fa-align-justify"></i>Últimos registros enviados
                    </div>
                    <div className="card-block" style={{ height: "450px", overflow: "auto" }}>
                        {
                            this.renderTabla()
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default LastReg;



// WEBPACK FOOTER //
// ./src/views/dashBoard/LastReg.js